import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import TrackVisibility from "react-on-screen"
import './SingUp.css';

export default function SignUp() {
  return (

    <form className="contact" action="https://formsubmit.co/artecrochenatal@hotmail.com"
      method="POST">
      <input className='focus-input' type="hidden" name="_next" value="http://localhost:3000/sign-up" />
      <input type="hidden" name="_captcha" value="false" />
      <Container></Container>
      <TrackVisibility>
        <Row className="align-items-center">
          <Col size={12} sm={6} className="px-1">
            <h2>Entre em contato conosco!</h2>
            <input className='in' type="text" name="name" placeholder="Nome" />
          </Col>
          <Col size={12} sm={6} className="px-1">
            <input className='in' type="text" name="subject" placeholder="Assunto" />
          </Col>
          <Col size={12} sm={6} className="px-1">
            <input className='in' type="text" name="phone" placeholder="Telefone" />
          </Col>
          <Col size={12} sm={6} className="px-1">
            <input className='in' type="email" name="email" placeholder="Email" />
          </Col>
        </Row>
      </TrackVisibility>
      <textarea name="message" placeholder="Mensagem"></textarea>
      <button className='login-form-btn' type="submit">Enviar</button>
    </form>
  )
}
